import { j as l } from "../../../jsx-runtime-B6kdoens.js";
import { useRef as f, useMemo as b } from "react";
import { a as d } from "../../../index-CROKJrb5.js";
import { c as u } from "../../../create-component-CBAeEoQ6.js";
import { FormControl as k } from "../../FormControl/index.js";
import { b as C, F as h } from "../../../FormControlContext-C7A4R-3o.js";
const j = { role: "listbox" }, F = u(
  "CheckboxGroupBase",
  ({
    children: r,
    className: t,
    defaultValue: s,
    id: o,
    name: c,
    onChange: e,
    size: x,
    state: a,
    type: i = "checkbox",
    value: m,
    ...p
  }) => {
    const [n] = C({
      id: o,
      name: c,
      onChange: e,
      type: i,
      state: a,
      size: x,
      value: m || s
    });
    return /* @__PURE__ */ l.jsx(h.Provider, { value: n, children: /* @__PURE__ */ l.jsx(
      k,
      {
        ...p,
        as: "div",
        fieldProps: j,
        className: d(
          '[&_[role="listbox"]]:cur-flex [&_[role="listbox"]]:cur-flex-col [&_[role="listbox"]]:cur-gap-4',
          t
        ),
        children: r
      }
    ) });
  }
), B = u(
  "CheckboxGroup",
  ({ onChange: r, values: t, ...s }) => {
    const o = f(
      Array.isArray(t) ? [...t] : []
    ), c = b(
      () => r ? (e) => {
        e.target.checked ? o.current.push(e.target.value) : o.current.splice(
          o.current.indexOf(e.target.value),
          1
        ), r == null || r(e, [...o.current]);
      } : void 0,
      [r]
    );
    return /* @__PURE__ */ l.jsx(
      F,
      {
        onChange: c,
        value: t,
        ...s
      }
    );
  }
);
export {
  B as CheckboxGroup,
  F as CheckboxGroupBase
};
//# sourceMappingURL=index.js.map
